var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollapseExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.8799,
    y1: 9.1362,
    x2: 23.8799,
    y2: 40.5454,
    gradientTransform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.9852 22.7466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#407A60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005443"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M23.613,3.019c-1.266,0-2.293,1.027-2.292,2.292c-0.001,1.267,1.185,2.452,2.452,2.452l13.111,0.162 L26.417,18.392l-6.987,6.987L8.963,35.846L8.802,22.734c0-1.267-1.186-2.453-2.453-2.452c-1.265-0.002-2.292,1.026-2.292,2.292 l0.01,20.949l21.513,0.009c0.633,0,1.227-0.236,1.641-0.651c0.415-0.414,0.712-0.947,0.712-1.582 c0.001-1.264-0.946-2.212-2.212-2.212l-13.674,0.16l10.625-10.625l6.987-6.987l10.626-10.625l-0.159,13.674 c0,1.266,0.946,2.213,2.212,2.212c0.633,0,1.165-0.297,1.58-0.712c0.415-0.414,0.651-1.008,0.651-1.642L44.561,3.029L23.613,3.019z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseExpand);
export default __webpack_public_path__ + "static/media/collapse_expand.86d62041cb3ba56a9bf4c1d865171fdd.svg";
export { ForwardRef as ReactComponent };